import { isObject, isString } from '@ngx-translate/core';

import { GbeErrorCodes } from '../models/gbe/gbe-error-codes.enum';
import { GbeError } from '../models/gbe/gbe-error.model';

interface GbeRawError {
  error: {
    errorCode?: GbeErrorCodes;
    errorMessage?: string;
    details?: object;
    [key: string]: unknown;
  };
}

function parseDetails(
  baseObject: Record<string, unknown>
): Record<string, unknown> | undefined {
  const details: Record<string, unknown> = {
    ...(baseObject['details'] || {})
  };
  for (const key in baseObject) {
    if (key !== 'errorCode' && key !== 'errorMessage' && key !== 'details') {
      details[key] = baseObject[key];
    }
  }

  return Object.keys(details).length > 0 ? details : undefined;
}

export function parseGbeError(error: unknown): GbeError {
  if (isObject(error)) {
    const gbeError = (error as unknown as GbeRawError).error;
    const errorCode = gbeError.errorCode;
    const errorMessage = gbeError.errorMessage;

    // matches GbeError with a known error code
    if (
      isString(errorCode) &&
      isString(errorMessage) &&
      Object.values(GbeErrorCodes).includes(errorCode)
    ) {
      const details = parseDetails(gbeError);
      return {
        errorCode,
        errorMessage,
        ...(details !== undefined && { details })
      } as GbeError;
    }

    // matches GbeError with an unknown error code
    if (
      isString(errorCode) &&
      isString(errorMessage) &&
      !Object.values(GbeErrorCodes).includes(errorCode)
    ) {
      const details = gbeError.details || parseDetails(gbeError);
      return {
        errorCode: GbeErrorCodes.UNKNOWN_ERROR_CODE,
        errorMessage,
        ...(details !== undefined && { details })
      };
    }
  }

  return {
    errorCode: GbeErrorCodes.UNKNOWN_ERROR_CODE,
    errorMessage: 'An unknown error occurred'
  };
}
